import { requestKey } from './withdrawal';

const PREFIX = 'crowd_withdrawal_pending:v1:';
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function normalize(payload) {
  // Whitelist payment metadata: never persist wallet credentials or other form fields.
  return {
    crowdWalletId: payload.crowdWalletId,
    targetWalletType: String(payload.targetWalletType).trim(),
    targetWalletNo: String(payload.targetWalletNo).trim(),
    amount: Number(payload.amount)
  };
}

function signature(payload) {
  const normalized = normalize(payload);
  return JSON.stringify([String(normalized.crowdWalletId), normalized.targetWalletType,
    normalized.targetWalletNo, normalized.amount]);
}

async function storageKey(payload, token) {
  if (!token) throw new Error('Authenticated session required');
  // Scope by authenticated session without copying the bearer token into sessionStorage.
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(token));
  const scope = Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join('');
  return `${PREFIX}${scope}:${encodeURIComponent(signature(payload))}`;
}

export async function getPendingWithdrawal(payload, token) {
  const key = await storageKey(payload, token);
  const saved = sessionStorage.getItem(key);
  let request;
  if (saved !== null) {
    request = JSON.parse(saved);
    if (!request || !UUID.test(request.requestKey) || !request.payload || signature(request.payload) !== signature(payload)) {
      throw new Error('Invalid pending withdrawal');
    }
  } else {
    request = { requestKey: requestKey(), payload: normalize(payload) };
    const serialized = JSON.stringify(request);
    sessionStorage.setItem(key, serialized);
    if (sessionStorage.getItem(key) !== serialized) throw new Error('Pending withdrawal was not persisted');
  }
  return { ...normalize(request.payload), requestKey: request.requestKey };
}

export async function clearAcceptedWithdrawal(payload, token) {
  const key = await storageKey(payload, token);
  const saved = sessionStorage.getItem(key);
  if (saved !== null && JSON.parse(saved).requestKey === payload.requestKey) sessionStorage.removeItem(key);
}

export function clearPendingWithdrawals() {
  // Storage may be disabled; logout must still remove authentication in that case.
  try {
    for (let index = sessionStorage.length - 1; index >= 0; index--) {
      const key = sessionStorage.key(index);
      if (key && key.startsWith(PREFIX)) sessionStorage.removeItem(key);
    }
  } catch (_) { /* No request may be sent while persistent storage is unavailable. */ }
}
